<ng-container *ngIf="loaderUserDetails$ | async">
  <div class="loader-overlay">
    <div class="custom-loader"></div>
  </div>
</ng-container>

<router-outlet></router-outlet>

<app-toast></app-toast>
